// MUI Components
import {
  Box,
  Button,
  Tooltip
} from '@mui/material';

// lucide Icons
import {
  ChevronLeft,
  ChevronRight,
  Award,
  SkipForward
} from 'lucide-react';

// Contexts
import { useTheme } from '../../contexts/ThemeContext';

export default function GameNavigation({
  currentIndex,
  totalProducts,
  onPrevious,
  onNext,
  onSkip,
  isComplete
}) {
  const { theme } = useTheme();

  return (
    <Box display="flex" justifyContent="space-between" gap={2} mt={3}>
      <Box display="flex" alignItems="center" gap={2}>
        <Button
          onClick={onPrevious}
          disabled={currentIndex === 0}
          variant="outlined"
          color="secondary"
          startIcon={<ChevronLeft size={18} />}
          sx={{
            borderRadius: 2,
            fontWeight: 600,
            fontFamily: theme.fontFamily,
            minWidth: 120,
            py: 1,
            opacity: currentIndex === 0 ? 0.5 : 1,
            borderWidth: 1.5,
            transition: 'all 0.2s',
            '&:hover': currentIndex > 0 ? {
              borderWidth: 1.5,
              background: `${theme.color.secondary}15`,
              transform: 'translateX(-2px)'
            } : {}
          }}
        >
          Previous
        </Button>
      </Box>

      <Box sx={{ display: 'flex', gap: 2 }}>
        <Tooltip title="Skip this product" arrow>
          <Button
            onClick={onSkip}
            variant="text"
            color="warning"
            startIcon={<SkipForward size={18} />}
            sx={{
              borderRadius: 2,
              fontWeight: 600,
              fontFamily: theme.fontFamily,
              minWidth: 80,
              py: 1,
              transition: 'all 0.2s',
              '&:hover': {
                background: `${theme.accent.warning}10`,
                transform: 'translateY(-2px)'
              }
            }}
          >
            Skip
          </Button>
        </Tooltip>
        <Button
          onClick={onNext}
          variant="contained"
          color="primary"
          endIcon={currentIndex < totalProducts - 1 ? <ChevronRight size={18} /> : <Award size={18} />}
          disabled={!isComplete}
          sx={{
            borderRadius: 2,
            fontWeight: 600,
            fontFamily: theme.fontFamily,
            minWidth: 120,
            py: 1,
            boxShadow: 2,
            transition: 'all 0.2s',
            '&:hover': {
              boxShadow: 3,
              transform: 'translateX(2px)'
            }
          }}
        >
          {currentIndex < totalProducts - 1 ? 'Next' : 'Finish'}
        </Button>
      </Box>
    </Box>
  );
}
